import { useMutation } from '@tanstack/react-query';
import { UserNotificationPreferencesStore } from '@stores/UserNotificationPreferencesStore';

export type RawCommunicationPreference = {
  notificationPreferenceId: number;
  notificationTypeId: number;
};

export class SaveCommunicationPreferencesAction {
  constructor(private readonly store: UserNotificationPreferencesStore = new UserNotificationPreferencesStore()) {}

  async Execute(raw: RawCommunicationPreference[]) {
    await this.store.create(raw);
  }
}

export const useSaveCommunicationPreferencesAction = () =>
  useMutation({
    mutationFn: async (raw: RawCommunicationPreference[]) => {
      const action = new SaveCommunicationPreferencesAction();
      return action.Execute(raw);
    },
  });
